/**
 * @Description:
 * 获取城市逻辑：
 1. url中的城市参数永远优先，存本地
 2 上次访问tuanche域名的定位
 3. GPS定位，存本地
 4. IP定位，存本地
 5. 默认城市（北京），不存本地
 * @author liupeng
 * @date 2019/8/21
 */
import merge from 'webpack-merge';
import {request} from "./request.js"
import {cookie} from "./cookie.js";
import {url} from "./url.js"

const cityInfo = new class{
  constructor(){
    this.longitude = ''
    this.latitude = ''
  }

  /**
   * 初始化
   */
  init(py){
    console.log(py)
    let cityPy = py
    let cityData = JSON.parse(cookie.getCookie('cityInfo'))
    /* 如果grade优先级存在 */
    if(cityData && cityData.grade){
      return this.getLocalCity()
    }
    if(cityPy){
      return this.getCityId(cityPy)
    }else if(cityData) {
      return this.getLocalCity()
    }else {
      return this.getGpsCity()
    }
  }

  /**
   * 根据城市拼音获取城市信息
   */
  getCityId(cityPy){
    // console.log('1.')
    let self = this
    return new Promise(function(resolve){
      request.get({
        url:"/baseData/city/location?cityPy="+cityPy,
        baseURL: url.baseUrl,
        success:function(res){
          let result = res.data.response.result;
          if(res.data.responseHeader.status == 200){
            /*将获取到的信息存储在本地*/
            // city.set(result)
            let val = {
              id: result.id,
              name: escape(result.name),
              py: result.py
            }
            val = JSON.stringify(val)
            cookie.setCookie('cityInfo',val,30,'/','.tuanche.com')
            resolve(self.result())
          }
        },
        error:function(){
          resolve(self.getCityIp())
        }
      });
    })
  }

  /**
   * 获取本地城市信息
   */
  getLocalCity(){
    // console.log('2.')
    let self = this
    return new Promise(function(resolve){
      resolve(self.result())
    })
  }

  /**
   * 获取gps定位城市信息
   */
  getGpsCity(){
    var self = this;
    if(this.isWeiXin()){
      return this.getConfig()
    }else{
      return this.getCurrentPosition()
    }
  }

  //判断当前环境是否是微信环境
  isWeiXin () {
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      return true;
    } else {
      return false;
    }
  }
  /**
   * 通过config接口注入权限验证配置
   * 参数见通用参数说明
   */
  getConfig(){
    // console.log('3.')
    let self = this;
    let dateStram = (new Date()).getTime();
    return new Promise(function(resolve,reject){
      $.ajax({
        type:"post",
        url:url.wxAuthUrl+"/wx/getWeChatShareConfig",
        headers:{
          'Content-Type':'application/x-www-form-urlencoded'
        },
        data:{"url":encodeURIComponent(window.location.href),'appId':url.wxAppId},
        async:false,
        'beforeSend': function (XMLHttpRequest,settings) {
        },
        success:function(res){
          let resData =JSON.parse(res);
          if(resData.response.result){
            wx.config({
              debug: false,
              appId: resData.response.result.appId, // 必填，公众号的唯一标识
              timestamp: resData.response.result.timestamp, // 必填，生成签名的时间戳
              nonceStr: resData.response.result.nonceStr, // 必填，生成签名的随机串
              signature: resData.response.result.signature,// 必填，签名，见附录1
              jsApiList: ["getLocation"]
            });
          }
          else{
            console.log("cofig参数返回结构错误");
            return;
          };
          wx.ready(function(){
            resolve(self.getWXLocation())
          })
        },
        error:function(jqXHR, textStatus, errorThrown) {
          console.log("errorConfig",self);
          resolve(self.getCurrentPosition())
        }
      })
    })
  }
  /**
   * 微信获取经纬度
   * 参数见通用参数说明
   */
  getWXLocation(options){
    // console.log('3-1.')
    let self =this;
    return new Promise(function(resolve, reject){
      wx.getLocation({
        type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
        success: function (res) {
          var obj={};
          obj.longitude = res.longitude;
          obj.latitude = res.latitude;
          resolve(self.getCityPosition(obj))
        },
        fail:function(res){
          resolve(self.getCityIp())
        },
        cancel: function (res) {
          resolve(self.getCityIp())
        }
      });

    })
  }
  /**
   * 定位失败的函数
   * @param e Object code,message code码，信息
   * @param options Object getCityPosition，getCityIp 经纬度获取城市信息的接口，ip获取城市信息的接口
   */
  getPositionError(e,options){
    let msg = e.code;
    let dd = e.message;
    return new Promise(function(resolve, reject) {
      resolve(options.getCityIp())
    })
  }
  /**
   * js获取经纬度
   * 参数见通用参数说明
   */
  getCurrentPosition(options){
    // console.log('4.')
    var self = this;
    return new Promise(function(resolve,reject){
      if(navigator.geolocation) {
        //创建定时器
        let timer=setTimeout(function(){
          self.getPositionError({code:"PERMISSION_DENIED",msg:"不允许定位"})
        },10000)
        navigator.geolocation.getCurrentPosition(
          function (position) {
            //清除定时器
            clearTimeout(timer);
            var obj={};
            obj.longitude = position.coords.longitude;
            obj.latitude = position.coords.latitude;
            resolve(self.getCityPosition(obj))
          },
          function (e) {
            //清除定时器
            clearTimeout(timer);
            var msg = e.code;
            var dd = e.message;
            // console.log(msg)
            // console.log(dd)
            resolve(self.getCityIp())
          },{timeout:5000}
        )
      }else{
        resolve(self.getCityIp())
        console.log('非浏览器')
      }
    })
  }

  /**
   *精准定位
   * @param type Number 1:手动调用;2: 默认调用
   */
  calibrationOfParameters(obj) {
    obj && (obj.longitude) && (this.longitude = obj.longitude);
    obj && (obj.latitude) && (this.latitude = obj.latitude);
  }
  /**
   *经纬度获取城市信息的接口
   * @param type Number 1:手动调用;2:默认调用
   * @param obj Object 包含属性positionText:定位文字;positionBtnShow:按钮显示状态;longitude:经度,latitude:纬度
   */
  getCityPosition(obj){
    // console.log('4-1.')
    let self = this;
    this.calibrationOfParameters(obj);
    // let result={
    //   latitude:this.latitude,
    //   longitude:this.longitude,
    //   cityFlag:1
    // };

    return new Promise(function(resolve, reject){
      request.get({
        url:`/baseData/city/location?latitude=${self.latitude}&longitude=${self.longitude}&cityFlag=1`,
        baseURL: url.baseUrl,
        headers:{
          "Content-Type": "application/x-www-form-urlencoded"
        },
        // data: result,
        success:function(res){
          var result = res.data.response.result;
          if(res.data.responseHeader.status == 200){
            /*将获取到的信息存储在本地*/
            let val = {
              id: result.id,
              name: escape(result.name),
              py: result.py
            }
            val = JSON.stringify(val)
            cookie.setCookie('cityInfo',val,30,'/','.tuanche.com')
            resolve(self.result())
          }
        },
        error:function(){
          resolve(self.getCityIp())
        }
      });

    })
  }
  /**
   *ip获取城市信息的接口
   * @param type Number 1:手动调用;2:默认调用
   * @param obj Object 包含属性positionText:定位文字;positionBtnShow:按钮显示状态,longitude:经度,latitude:纬度
   */
  getCityIp(obj){
    let self = this;
    this.calibrationOfParameters(obj);
    return new Promise(function (resolve, reject) {
      request.get({
        url: "/qiandao/index/getLocationByIp",
        baseURL: url.baseUrl,
        success:function(res){
          let result = res.data.response.result;
          if(res.data.responseHeader.status == 200){
            /*将获取到的信息存储在本地*/
            let val = {
              id: result.id,
              name: escape(result.name),
              py: result.py
            }
            val = JSON.stringify(val)
            cookie.setCookie('cityInfo',val,30,'/','.tuanche.com')
            resolve(self.result())
          }
        },
        error:function(){

        }
      });
    })
  }

  /**
   * 最终返回结果
   */
  result(){
    let cityinfo = cookie.getCookie('cityInfo')
    let obj = JSON.parse(cityinfo)
    let res = {
      id: obj.id,
      name: unescape(obj.name),
      py: obj.py
    }
    if(res.id){
      /* 此处是为了解决城市优先级问题，删除grade字段 */
      let delGrade = {
        id: obj.id,
        name: escape(obj.name),
        py: obj.py
      }
      cookie.setCookie('cityInfo',JSON.stringify(delGrade),30,'/','.tuanche.com')
      return res
    }else {
      return {name:"北京",id:"10",py:"bj",default:1}
    }
  }

  /**
   * 跳转到城市选择页
   */
  goToCityPage(type){
    let obj = this.result();
    if(type){
      window.location.href = url.newCarPath + 'citySelected?cityId=' + obj.id + "&citytype=" + type
    }else{
      window.location.href = url.newCarPath + 'citySelected?cityId=' + obj.id
    }
  }
}

export default cityInfo


// WEBPACK FOOTER //
// ./static/js/lib/cityInfo.js